import type { IntlShape } from 'react-intl-next';

import type { ExtensionManifest } from '@atlaskit/editor-common/extensions/extension-manifest';

import type { NativeTabsParameters } from '../nativeTabsTypes.ts';

import { buildBaseManifest } from './baseManifest.tsx';

/**
 * Renderer-side manifest for the Native Tabs extension. Spreads the shared
 * shape from `buildBaseManifest` and points `render()` at `TabsRenderer`.
 *
 * No `quickInsert` — slash menu doesn't run in view mode.
 */
export const getNativeTabsRendererManifest = (
	intl: IntlShape,
): ExtensionManifest<NativeTabsParameters> => {
	const base = buildBaseManifest(intl);

	return {
		...base,
		modules: {
			nodes: {
				default: {
					type: 'multiBodiedExtension',
					// @ts-expect-error — `__allowBodiedOverride` is recognised by the MBE plugin
					// at runtime but isn't yet on `ExtensionModuleNode`. Remove when upstream types update.
					__allowBodiedOverride: true,
					// editor-core's MBE plugin mounts this with `{ node, actions, ... }` injected.
					render: async () => {
						const mod = await import(
							/* webpackChunkName: "loadable-NativeTabsRenderer" */ '../components/TabsRenderer.tsx'
						);
						return mod.TabsRenderer;
					},
				},
			},
		},
	};
};
